export default __webpack_public_path__ + "static/media/case2 (4).d7f0172b.jpg";